export function buildUserOrdersByDatePath(date, filterSite = "") {
  const params = new URLSearchParams({ filter_date: date });
  if (filterSite) {
    params.set("filter_site", filterSite);
  }
  return `/package/user-order-app/?${params.toString()}`;
}
